import { DateTime } from 'luxon';
const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const setDayOfWeek = (input) => {
  let inputName = input.name;
  let inputValue = input.value;

  // console.log(inputName, "has been changed. updating", `${inputName}_DAY`);
  let dayObject = DateTime.fromFormat(inputValue, "MM-dd-yyyy");
  document.querySelectorAll(`[data-setdayofweek="${inputName}_DAY"]`).forEach((element) => {
    element.innerText = weekdays[dayObject.weekday - 1] || "";
  });
};

export default setDayOfWeek;
